import { createUseStyles } from "react-jss";

export const RequestPendingAssigmentContainerStyle = createUseStyles((theme: any) => ({
    containerList: {
        display: "flex",
        justifyContent: "space-between",
    },
}));
